import { Component } from '@angular/core';
import { AuthService } from './authentication/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'ng5 Backoffice';

  constructor(private authService: AuthService) {
  }

  //isSessionAboutToExpire = false;
  //authentication = this.authService.authentication;
  //externalAuthData = this.authService.externalAuthData;

  ngOnInit() {
    //this.authService.checkInitialLogOut();
    //this.authService.sessionExpiresReminder(this.updateSessionAboutToExpireScope);
  }

  logOut(): void {
    //this.authService.logOut();
    //$location.path('/login');
  };

  updateSessionAboutToExpireScope(): void {
    //this.isSessionAboutToExpire = true;
    // this.$apply();
  }
  

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts